import { env } from '@/lib/env';
import createClient, { type Middleware } from 'openapi-fetch';
import createQueryClient from 'openapi-react-query';
import type { paths } from './schema';

// Middleware to handle 401 responses
const unauthenticatedMiddleware: Middleware = {
  async onResponse({ response }) {
    if (response.status === 401) {
      // Only redirect to login if we're not already on an auth page
      if (!window.location.pathname.startsWith('/login')) {
        // Clear any local state and redirect to login
        window.location.href = '/login';
      }
    }
    return response;
  },
};

export const apiClient = createClient<paths>({
  baseUrl: env.VITE_API_BASE_URL,
  credentials: 'include', // Include cookies with every request
});

// Register the middleware
apiClient.use(unauthenticatedMiddleware);

export const queryClient = createQueryClient(apiClient);
